function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { white, gray50, gray100, gray400, gray600, gray800, red600, focusShadow } from '../../theme/colors';
import { size4, CONTROL_SIZE_MAP } from '../../theme/scale';
import { duration150, easeInOut } from '../../theme/animation';
import { fontRegular } from '../../theme/fonts';
import InputWrapper from '../input-wrapper';
const NumberInputWrapper = styled.div`
  position: relative;
`;
const Input = styled.input`
  ${({
  $size
}) => $size && {
  ...CONTROL_SIZE_MAP[$size]
}}
  border: 1px solid;
  border-color: ${({
  hasErrorMessage
}) => hasErrorMessage ? red600 : gray400};
  border-radius: ${size4};
  color: ${gray800};
  font-family: ${fontRegular};
  transition: border ${duration150} ${easeInOut}, box-shadow ${duration150} ${easeInOut};
  width: 100%;

  &::placeholder {
    color: ${gray600};
  }

  &:hover {
    background: ${gray50};
  }

  &:focus {
    background: ${white};
    border-color: ${({
  hasErrorMessage
}) => hasErrorMessage ? red600 : gray400};
    box-shadow: 0 0 0 3px ${focusShadow};
    outline: none;
  }

  &[readonly],
  &[disabled] {
    background: ${gray100};
    cursor: not-allowed;
  }
`;
export const NumberField = /*#__PURE__*/forwardRef(({
  value,
  onChange,
  nativeOnChange,
  onInput,
  size = 'md',
  id,
  placeholder,
  label,
  hint,
  errorMessage,
  hideLabel = false,
  smallLabel = false,
  caption,
  disabled = false,
  min,
  max,
  step,
  width,
  ...props
}, ref) => {
  const handleChange = event => {
    return event.target.value && typeof Number(event.target.value) === 'number' ? event.target.valueAsNumber : event.target.value;
  };
  return /*#__PURE__*/React.createElement(InputWrapper, {
    isNumber: true,
    id,
    label,
    hint,
    errorMessage,
    hideLabel,
    caption,
    smallLabel,
    width
  }, /*#__PURE__*/React.createElement(NumberInputWrapper, null, /*#__PURE__*/React.createElement(Input, _extends({
    id,
    placeholder,
    disabled,
    min,
    max,
    step,
    ref,
    value,
    $size: size,
    type: "number",
    onChange: event => {
      if (nativeOnChange) nativeOnChange(event);
      if (onChange) onChange(handleChange(event));
    },
    onInput: onInput,
    hasErrorMessage: !!errorMessage
  }, props))));
});
NumberField.displayName = 'NumberField';
export default NumberField;
//# sourceMappingURL=index.js.map